$(document).ready(function(){
    
    var $reviewBtn = $("a#js-reviewBtn"),
        $reviewContent = $("#js-reviewContent");
    
    $reviewBtn.on("click", function(e){
        e.preventDefault();
        $reviewContent.slideToggle();
        $(this).toggleClass('active');
    });

});